import component from "./DrawLots";

export default component;
